import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

export const SHORTLINKS = {
  ig: 'instagram',
  fb: 'facebook',
  tt: 'tiktok',
  rd: 'reddit',
  x: 'x',
  th: 'threads',
  yt: 'youtube',
};

export default function GoRedirect() {
  const { pathname } = useLocation();

  useEffect(() => {
    const short = pathname.replace(/\//g, '');
    const source = SHORTLINKS[short];
    if (!source) {
      window.location.replace('/');
      return;
    }
    try {
      fetch(`${API}/api/track/click`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ source }),
        keepalive: true,
      }).catch(() => {});
    } catch (e) { /* ignore */ }
    window.location.replace(`/?utm_source=${source}&utm_medium=social&utm_campaign=bio_link`);
  }, [pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-pink-50" data-testid="go-redirect">
      <p className="text-gray-400 text-sm">Taking you to CoupleIn…</p>
    </div>
  );
}
